module.exports = __webpack_public_path__ + "img/BANNER_DASH_GREENN4.182d3581.png";